import getSubdomain from '@/common/getSubdomain';

export default function useIsSsoEntra(): boolean {
  const ssoSubDomains = import.meta.env.VITE_SSO_ENTRA_SUBDOMAINS.split(',');
  const subDomein = getSubdomain();
  return subDomein && ssoSubDomains.includes(subDomein);
}
